export const StringConstant = {
    REGION_NA: "NA",
    REGION_EU: "EU",
    REGION_FE: "FE",
    REGION_IN: "IN",
    APP_TITLE: "Induct",
    AVERY_PRINTER: "AVERY_PRINTER"
};